import React, { ReactElement } from "react";
import { TabProps } from "./tab.types";

export const Tab = ({ isTabSet, children }: TabProps): ReactElement => {
  if (!isTabSet) {
    throw new Error(
      "You tried to use the <Tab> component without wrapping it in <Tabs>."
    );
  }
  return <div>{children}</div>;
};

Tab.displayName = "Tab";
